import React from "react"
import { Analytic, COxAnalysis, CPPOptAnalysis, CPPOptFlexAnalysis, MAPOptAnalysis, MAPOptFlexAnalysis, OnDemandAnalysis, PRxAnalysis, TimedOnDemandAnalysis } from "../../../Types/AnalysisDetails"
import { EditPRx } from "./EditPRx"
import { EditCOx } from "./EditCOx"
import { EditCPPOpt } from "./EditCPPOpt"
import { AnalysisBuilder } from "./AnalysisBuilder"
import { EditMAPOpt } from "./EditMAPOpt"
import { EditCPPOptFlex } from "./EditCPPOptFlex"
import { EditMAPOptFlex } from "./EditMAPOptFlex"
import { QEEGTrendParameters } from "./QEEGTrendParameters"

export const getAnalysisEditor = (analysis: OnDemandAnalysis | undefined, rawDataKey: string | undefined, onChange: (analysis: OnDemandAnalysis | undefined) => void) => {
    switch (analysis?.analytic) {
        case Analytic.PRx: return <EditPRx initialState={analysis as PRxAnalysis} onChange={onChange} />
        case Analytic.COx: return <EditCOx initialState={analysis as COxAnalysis} onChange={onChange} />
        case Analytic.CPPOpt: return <EditCPPOpt initialState={analysis as CPPOptAnalysis} onChange={onChange} />
        case Analytic.MAPOpt: return <EditMAPOpt initialState={analysis as MAPOptAnalysis} onChange={onChange} />
        case Analytic.CPPOpt_FLEX: return <EditCPPOptFlex initialState={analysis as CPPOptFlexAnalysis} onChange={onChange} />
        case Analytic.MAPOpt_FLEX: return <EditMAPOptFlex initialState={analysis as MAPOptFlexAnalysis} onChange={onChange} />
        case Analytic.QEEG_ADR:
        case Analytic.QEEG_SR:
            return <QEEGTrendParameters analytic={analysis.analytic} />

        default:
            return <AnalysisBuilder 
                initialState={analysis as TimedOnDemandAnalysis | undefined}
                rawDataKey={rawDataKey as string} 
                onChange={onChange} />
    }
}
